import type { OpenActivitySummaryAction } from './typings'

export const openActivitySummaryActionCreator =
  (): OpenActivitySummaryAction => ({ type: 'activitySummary/open' })
